import { useCallback } from 'react';

import { useAgenda } from '@app/hooks/useAgenda';
import { useLogoImage } from '@app/hooks/useLogoImage';
import { useOrderable } from '@app/hooks/useOrderable';
import { formFields, getEventPayload, nonRequiredFields } from '@app/utils/eventUtils';
import { formatNonRequiredFields, validateFormFields } from '@app/utils/validateUtils';

import { GenericObject } from '@app/components/common/Table/DefaultTable/types';
import EditView from '@app/components/common/views/EditView';

import { EventForm } from './EventForm';

export const EditEvent = () => {
  const { logoImage: sponsorLogo, handleChangeImageLogo: handleChangeSponsorLogo } = useLogoImage();
  const { logoImage: eventLogo, handleChangeImageLogo: handleChangeEventLogo } = useLogoImage();
  const { agenda, rowModesModel, handleChangeAgenda, handleChangeRowModesModel, handleClickAddAgenda } = useAgenda();
  const { selected, handleChangeSelected, moveCard } = useOrderable();

  const validate = useCallback((values: GenericObject) => validateFormFields({ fields: formFields, values }), []);

  const transform = (values: GenericObject) => {
    formatNonRequiredFields(values, nonRequiredFields);

    return getEventPayload(values, agenda, selected, sponsorLogo, eventLogo);
  };

  return (
    <div>
      <EditView resourceSingular="event" validate={validate} transform={transform} mutationMode="pessimistic">
        <EventForm
          sponsorLogo={sponsorLogo}
          selectedQuestions={selected}
          handleChangeSelectedQuestions={handleChangeSelected}
          reorderItems={moveCard}
          eventLogo={eventLogo}
          title="EDIT EVENT"
          handleChangeSponsorLogo={handleChangeSponsorLogo}
          handleChangeEventLogo={handleChangeEventLogo}
          agenda={agenda}
          rowModesModel={rowModesModel}
          handleChangeAgenda={handleChangeAgenda}
          handleChangeRowModesModel={handleChangeRowModesModel}
          handleClickAddAgenda={handleClickAddAgenda}
        />
      </EditView>
    </div>
  );
};
